import React, { useState, useRef, useEffect, useCallback } from "react";
import 'ag-grid-enterprise';
import * as Flags from 'country-flag-icons/react/3x2'
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import { countryToAlpha2 } from 'country-to-iso';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const CityList = () => {

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}`;
    const allCities = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.allCities}`;
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const perPage = 10;
    const [error, setError] = useState("")
    const gridRef = useRef();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const navigate = useNavigate();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'cityName', enableRowGroup: true, headerName: "City" },
        {
            field: 'country', enableRowGroup: true, cellRenderer: IconComponent
        }
    ]);

    function IconComponent(props) {
        let code = countryToAlpha2(props.value)
        const Flag = Flags[code?.toUpperCase()];
        return <span style={{ display: "flex" }}> {code && <Flag width={18} style={{ marginInline: "5px" }} />} <p>{props.value}</p></span>
    }

    const findCities = async () => {
        try {
            const list = await OAuthService.getList(allCities + '?sort=cityName,asc&size=1000');
            let cities = list.data
            cities = await Promise.all(cities.map(async (city) => {
                return {
                    id: city.id,
                    cityName : city.cityName,
                    country : city.country.name
                }
            }));
            setRowData(cities);
        } catch (error) {
            setError(error.message);
            console.log(error);
        }
    }

    const onGridReady = useCallback((params) => {
        findCities();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Cities.xlsx',
            sheetName: 'Cities'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findCities();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onRowDoubleClicked = (params) => {
        navigate('/editCities/' + selectedRows[0]?.id)
    }

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="City"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addCity"
                pageName="City List"
                error={error}
                deleteDisable={deleteDisable}
                successMsg={successMsg}
                gridRef={gridRef}
                snackState={snackState}
            />
            <div className="h-full">
                <AgGridTable
                    frameworkComponents={{
                        iconComponent: IconComponent
                    }}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'cityList'}
                />
            </div>
        </>
    )
}

export default CityList